/* ============================
   DP4Y Add-ons (A + Hardening)
   - Foto check meenemen
   - Add-ons meenemen
   - GEEN automatische gift meer (extra-steentjes-gratis is USP/garantie tekst, geen cart-item)
   - Cart attribute: "Foto check" + "photo_check"
   - Hardening:
     * form submit fallback
     * fetch(/cart/add.js) interceptor fallback
   ============================ */

(function () {
  'use strict';

  // ---------- helpers ----------
  function sleep(ms) { return new Promise(r => setTimeout(r, ms)); }

  async function fetchJson(url, opts) {
    const res = await fetch(url, Object.assign({ credentials: 'same-origin' }, opts || {}));
    try { return await res.json(); } catch (e) { return null; }
  }

  async function setCartAttributeFotoCheck(enabled) {
    return fetchJson('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          "Foto check": enabled ? "Foto check gekozen: voorbeeld binnen 3 uur via WhatsApp of e-mail." : "",
          "photo_check": enabled ? "1" : ""
        }
      })
    });
  }

  function qs(sel, scope) { return (scope || document).querySelector(sel); }
  function qsa(sel, scope) { return Array.from((scope || document).querySelectorAll(sel)); }

  // ---------- DOM refs ----------
  function getWraps() {
    return {
      photoWrap: document.getElementById('dp4y-photo-check'),
      addonsWrap: document.getElementById('dp4y-addons')
    };
  }

  function collectCheckedVariantIds(scope) {
    if (!scope) return [];
    return qsa('.dp4y-addons-cb:checked', scope)
      .map(cb => Number(cb.dataset.variantId))
      .filter(Boolean);
  }

  function getAllSelectedExtras() {
    const { photoWrap, addonsWrap } = getWraps();
    const photoIds = collectCheckedVariantIds(photoWrap);
    const addonIds = collectCheckedVariantIds(addonsWrap);
    const all = [].concat(photoIds).concat(addonIds);

    // unique + >0
    return Array.from(new Set(all.map(Number))).filter(Boolean);
  }

  async function addExtrasToCartOnce() {
    const extras = getAllSelectedExtras();
    if (!extras.length) return;

    // Foto check attribute sync
    const { photoWrap } = getWraps();
    const fotoCb = photoWrap ? qs('.dp4y-addons-cb', photoWrap) : null;
    if (fotoCb) {
      try { await setCartAttributeFotoCheck(!!fotoCb.checked); } catch (e) {}
    }

    // Add extras as separate add.js call (safe fallback)
    const items = extras.map(id => ({ id: Number(id), quantity: 1 }));
    await fetchJson('/cart/add.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({
    items,
    dp4y_internal: true
  })
});
  }

  // ---------- Foto check attribute binding ----------
  function bindFotoCheckAttribute() {
    const { photoWrap } = getWraps();
    if (!photoWrap) return;

    photoWrap.addEventListener('change', async (ev) => {
      const cb =
        ev.target &&
        ev.target.classList &&
        ev.target.classList.contains('dp4y-addons-cb')
          ? ev.target
          : null;

      if (!cb) return;

      try {
        await setCartAttributeFotoCheck(cb.checked);
      } catch (e) {
        console.warn('[DP4Y] setCartAttributeFotoCheck error', e);
      }
    });
  }

  // ---------- Booster hook ----------
  function bindBoosterAddHook() {
    const handler = async function (e) {
      try {
        const detail = e && e.detail ? e.detail : {};
        const form = detail.form;
        if (!form) return;

        const extras = getAllSelectedExtras();

        // Foto check attribute sync
        const { photoWrap } = getWraps();
        const fotoCb = photoWrap ? qs('.dp4y-addons-cb', photoWrap) : null;
        if (fotoCb) {
          await setCartAttributeFotoCheck(!!fotoCb.checked);
        }

        // Inject in Booster payload (als aanwezig)
        if (detail.json && Array.isArray(detail.json.items) && extras.length) {
          const existingIds = new Set(detail.json.items.map(x => Number(x.id)));
          extras.forEach(id => {
            if (!existingIds.has(Number(id))) {
              detail.json.items.push({ id: Number(id), quantity: 1 });
            }
          });
        }

        await sleep(50);
      } catch (err) {
        console.warn('[DP4Y] booster hook error', err);
      }
    };

    document.addEventListener('booster:cart:add', handler);
    document.addEventListener('booster:cart:beforeadd', handler);
    document.addEventListener('booster:cart:before-add', handler);
    document.addEventListener('booster:cart:badd', handler);
  }

  // ---------- HARDENING 1: native submit fallback ----------
  function bindNativeFormSubmitFallback() {
    document.addEventListener('submit', async (e) => {
      const form = e.target;
      if (!form || !form.matches || !form.matches('form[action="/cart/add"]')) return;

      // Alleen uitvoeren op pagina’s waar onze add-on UI bestaat
      const { photoWrap, addonsWrap } = getWraps();
      if (!photoWrap && !addonsWrap) return;

      // Na submit (Booster/Shopify) -> extras toevoegen
      // We gebruiken een micro delay zodat main item eerst kan landen
      setTimeout(() => {
        addExtrasToCartOnce().catch(() => {});
      }, 250);
    }, true);
  }

  // ---------- HARDENING 2: fetch interceptor (/cart/add.js) ----------
  function bindFetchInterceptor() {
    if (!window.fetch || window.__DP4Y_FETCH_PATCHED) return;
    window.__DP4Y_FETCH_PATCHED = true;

    const originalFetch = window.fetch;
    window.fetch = function (input, init) {
      const url = (typeof input === 'string') ? input : (input && input.url) ? input.url : '';
      const isCartAdd = typeof url === 'string' && url.indexOf('/cart/add') !== -1;

      const p = originalFetch.apply(this, arguments);

      if (isCartAdd && !(init && init.body && String(init.body).includes('"dp4y_internal":true'))) {
  p.then(() => {
    setTimeout(() => {
      addExtrasToCartOnce().catch(() => {});
    }, 250);
  }).catch(() => {});
}

      return p;
    };
  }

  function init() {
    bindBoosterAddHook();
    bindFetchInterceptor();

    document.addEventListener('DOMContentLoaded', () => {
      bindFotoCheckAttribute();
      bindNativeFormSubmitFallback();
    });
  }

  init();

function handleCartNotes() {
  const notes = document.querySelector(".dp4y-cart-notes-details");
  if (!notes) return;

  if (window.innerWidth < 769) {
    notes.removeAttribute("open");
  } else {
    notes.setAttribute("open", "");
  }
}

document.addEventListener("DOMContentLoaded", handleCartNotes);
window.addEventListener("resize", handleCartNotes);
document.addEventListener("booster:content:update", handleCartNotes);

})();